import styled from "styled-components";

export const SuggestionItem = styled.li`
  a {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.text.darkerGrey};
    column-gap: ${({ theme }) => theme.spacers.M};
    padding: ${({ theme }) => `${theme.spacers["2M"]} ${theme.spacers["2M"]}`};
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
    text-decoration: none;

    &:hover {
      background-color: ${({ theme }) => theme.colors.background.superLightGrey};
    }
  }
`;

export const SectionTitleWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.spacers.L};
`;

export const SuggestionText = styled.span`
  ${({ theme }) => theme.typography.RegularParagraph}
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  flex: 1;

  mark {
    font-weight: bold;
    background: inherit;
  }
`;

export const LeftIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.darkerGrey};
`;

export const RightIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.text.lightGrey};
`;
